<app-entity-mat-dialog-title title="System Notice"></app-entity-mat-dialog-title>

<div mat-dialog-content>
  <p class="incident-details-body">{{ data.message }}</p>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>
